import { isSlotBlocked } from 'src/consumer/helpers/utilFunctions'

export const filterBookedSlots = (bookedSlots, filters, currentMode) => {
  return bookedSlots?.filter((slot) => {
    if (isSlotBlocked(slot)) {
      if (currentMode === 'reassign') {
        return false
      }
      return filters?.unpaidEvents
    }
    switch (slot?.sessionStatus) {
      case 'marked-completed':
        return filters?.completedEvents
      default:
        return filters?.notStarted
    }
  })
}

export const DEFAULT_FILTERS = {
  rosterItems: true,
  unpaidEvents: true,
  paidEvents: true,
  completedEvents: true,
  notStarted: true,
} 